import { createSelector } from 'reselect';

import { getCoworkingWorkplacesSelector } from './getCoworkingWorkplacesSelector';

export const getCoworkingFlexWorkplaceSelector = createSelector(
  [getCoworkingWorkplacesSelector],
  workplaces => workplaces?.flex ?? null,
);
